import { CHARACTERS } from "@spieleparadies/shared";

/**
 * Asset-Pfade für "Rette Anna".
 *
 * Lege deine echten Dateien einfach unter `public/assets/games/rette-anna/...`
 * ab – die Pfade unten werden vom Boot-Loader benutzt. Fehlt eine Datei, baut
 * das Spiel sauber einen Platzhalter, damit du auch ohne fertige Assets
 * entwickeln und testen kannst.
 */
export const RETTE_ANNA_ASSETS = {
  images: {
    anna: "/assets/games/rette-anna/images/anna.png",
    monster: "/assets/games/rette-anna/images/monster.png",
    spike: "/assets/games/rette-anna/images/spike.png",
    platform: "/assets/games/rette-anna/images/platform.png",
    background: "/assets/games/rette-anna/images/background.png",
  },
  audio: {
    intro: "/assets/games/rette-anna/audio/intro.mp3",
    jump: "/assets/games/rette-anna/audio/jump.mp3",
    shoot: "/assets/games/rette-anna/audio/shoot.mp3",
    die: "/assets/games/rette-anna/audio/die.mp3",
    monster: "/assets/games/rette-anna/audio/monster.mp3",
    rescue: "/assets/games/rette-anna/audio/rescue.mp3",
    music: "/assets/games/rette-anna/audio/music.mp3",
  },
} as const;

/** Phaser-Texture-Key für einen Charakter-Sprite. */
export function characterSpriteKey(characterId: string): string {
  return `char-${characterId}`;
}

/**
 * Texture-Key für das Projektil eines Charakters. Pro `style` gibt es ein
 * eigenes Design (Olaf wirft Schneebälle, Buzz schießt Laser …). Fällt auf
 * die Standard-Kugel `bullet` zurück, wenn der Style unbekannt ist.
 */
export function bulletTextureKey(characterId: string): string {
  const character = CHARACTERS.find((c) => c.id === characterId);
  if (!character) return "bullet";
  return `bullet-${character.style}`;
}

/** Vom Loader genutzte Pfade pro Charakter (z. B. `/assets/characters/stitch.png`). */
export function characterAssetEntries(): Array<{ key: string; path: string }> {
  return CHARACTERS.map((c) => ({
    key: characterSpriteKey(c.id),
    path: `/assets/characters/${c.id}.png`,
  }));
}

export type RetteAnnaAssetKey = keyof typeof RETTE_ANNA_ASSETS.images
  | keyof typeof RETTE_ANNA_ASSETS.audio;
